import React, { useEffect, useState } from "react";
import { Col, Container, Row, Table, Button, Image } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { getApi } from "../../actions/structure.action";
import bhareeLogo from "../../assets/images/bhareeLogo.png";
import TimestampConverter from "../../utils/TimestampConverter";
import convertToLiters from "../../utils/convertToLiters";
import "./index.css";
import isEmpty from "../../utils/is-Empty";
import { appConstants } from "../../helpers/app-constants";

const Invoice = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { orderId } = useParams();
  const { currentOrder, gstStates, companyInfo } = useSelector((state) => {
    return state;
  });

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  useEffect(() => {
    getApi("getOrder", dispatch, "/" + orderId);
    getApi("getGstStates", dispatch);
    // getApi("getCompanyInfo", dispatch);
  }, [orderId, dispatch]);

  const [orderSubTotal, setOrderSubTotal] = useState(0.0);
  const [orderDiscount, setOrderDiscount] = useState(0.0);
  const [finalTotal, setFinalTotal] = useState(0.0);
  const [finalSGST, setFinalSGST] = useState(0.0);
  const [finalCGST, setFinalCGST] = useState(0.0);
  const [productVariant, setProductVariant] = useState({});
  const [billingStateCode, setBillingStateCode] = useState("");
  const [sellerStateCode, setSellerStateCode] = useState("");
  const [rateWithoutGST, setRateWithoutGST] = useState(0.0);
  const [totalWithoutGST, setTotalWithoutGST] = useState(0.0);
  const [deliveryWithoutGST, setDeliveryWithoutGST] = useState(0.0);
  const [deliveryCGST, setDeliveryCGST] = useState(0.0);
  const [deliverySGST, setDeliverySGST] = useState(0.0);
  const [deliveryRate, setDeliveryRate] = useState(0.0);
  const [grandTotalCGST, setGrandTotalCGST] = useState(0.0);
  const [grandTotalSGST, setGrandTotalSGST] = useState(0.0);
  const [handlingCGST, setHandlingCGST] = useState(0.0);
  const [handlingSGST, setHandlingSGST] = useState(0.0);
  const [handlingWithoutGST, setHandlingWithoutGST] = useState(0.0);
  const [handlingRate, setHandlingRate] = useState(0.0);

  const [hsnCGST, setHsnCGST] = useState(0);
  const [hsnSGST, setHsnSGST] = useState(0);
  const [hsnIGST, setHsnIGST] = useState(18);

  useEffect(() => {
    if (!isEmpty(currentOrder?.data)) {
      // console.log("CURRENT ORDER:: ", currentOrder?.data);
      // console.log("HSN GST:: ", currentOrder?.data?.hsn_gst);

      const hsnGST = parseFloat(currentOrder?.data?.hsn_gst) / 100;
      setHsnCGST((hsnGST * 100) / 2);
      setHsnSGST((hsnGST * 100) / 2);

      const mTotalAmount = parseFloat(currentOrder?.data?.totalAmount);
      let sTotal = currentOrder?.data?.price * currentOrder?.data?.moq;
      let discount = 0;
      if (currentOrder?.data?.offerPrice) {
        sTotal = currentOrder?.data?.moq * currentOrder?.data?.offerPrice;
        discount = currentOrder?.data?.price * currentOrder?.data?.moq - sTotal;
      }
      setOrderDiscount(discount);
      setOrderSubTotal(mTotalAmount);

      const fTotal =
        mTotalAmount +
        parseFloat(currentOrder?.data?.totalDelivery) +
        parseFloat(currentOrder?.data?.totalHandlingCharges || 0);
      setFinalTotal(fTotal);

      const sTotalWithoutGST = parseFloat(currentOrder?.data?.totalAmount) / (1 + hsnGST);
      setTotalWithoutGST(sTotalWithoutGST.toFixed(2));

      const gstValue = (parseFloat(currentOrder?.data?.totalAmount) - sTotalWithoutGST) / 2;
      setFinalCGST(gstValue);
      setFinalSGST(gstValue);

      const mRate = (sTotalWithoutGST / currentOrder?.data?.moq).toFixed(2);
      setRateWithoutGST(mRate);

      const variant = currentOrder?.data?.product_variant_id;
      if (variant && variant.length > 0) {
        setProductVariant(variant[0]);
      }

      const mDeliveryWithoutGST = parseFloat(currentOrder?.data?.totalDelivery) / 1.18;
      setDeliveryWithoutGST(mDeliveryWithoutGST.toFixed(2));

      const mDeliveryGSTValue =
        (parseFloat(currentOrder?.data?.totalDelivery) - mDeliveryWithoutGST) / 2;
      setDeliveryCGST(mDeliveryGSTValue);
      setDeliverySGST(mDeliveryGSTValue);

      const mDeliveryRate = (mDeliveryWithoutGST / currentOrder?.data?.moq).toFixed(2);
      setDeliveryRate(mDeliveryRate);

      const mHandlingChargesWithoutGST =
        parseFloat(currentOrder?.data?.totalHandlingCharges) / 1.18;
      setHandlingWithoutGST(mHandlingChargesWithoutGST.toFixed(2));
      const mHandlingGSTValue =
        (parseFloat(currentOrder?.data?.totalHandlingCharges) - mHandlingChargesWithoutGST) / 2;
      setHandlingCGST(mHandlingGSTValue);
      setHandlingSGST(mHandlingGSTValue);
      const mHandlingRate = (mHandlingChargesWithoutGST / currentOrder?.data?.moq).toFixed(2);
      setHandlingRate(mHandlingRate);

      const mGrandTotalGSTValue =
        parseFloat(gstValue.toFixed(2)) +
        parseFloat(mDeliveryGSTValue.toFixed(2)) +
        parseFloat(mHandlingGSTValue.toFixed(2));
      setGrandTotalCGST(mGrandTotalGSTValue);
      setGrandTotalSGST(mGrandTotalGSTValue);
    }
  }, [currentOrder]);

  useEffect(() => {
    if (!isEmpty(gstStates?.data) && !isEmpty(currentOrder?.data)) {
      const mState = currentOrder?.data?.billing_address_id?.state;
      const foundState = gstStates.data.find((state) => state.state_name === mState);
      if (foundState) {
        setBillingStateCode(foundState.state_code);
      }

      const sellerState = currentOrder?.data?.seller_address_id?.state;
      const sellerFoundState = gstStates.data.find((state) => state.state_name === sellerState);
      if (sellerFoundState) {
        setSellerStateCode(sellerFoundState.state_code);
      }
    }
  }, [currentOrder, gstStates]);

  const handlePrint = () => {
    window.print();
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <>
      {currentOrder?.data?.invoice_status === true && (
        <>
          <Container className="mt-2 mb-2 p-0 no-print">
            <Row>
              <Col className="text-start">
                <Button className="btn btn-primary btn-sm" onClick={handleGoBack}>
                  <i class="bi bi-chevron-left"></i> Back
                </Button>
              </Col>
              <Col className="text-end">
                <Button className="btn btn-primary btn-sm" onClick={handlePrint}>
                  <i class="bi bi-printer"></i> Print
                </Button>
              </Col>
            </Row>
          </Container>
          <Container className="p-4 w-100 invoice-container mb-4 mt-4 a4-container">
            <Row className="mb-1">
              <Col md={9} className="text-start">
                <h3>Tax Invoice for {currentOrder?.data?.billing_address_id?.full_name}</h3>
              </Col>
              <Col md={3} className="d-flex justify-content-end align-items-center">
                <Image src={bhareeLogo} alt="bhareeLogo" style={{ width: 125 }} />
              </Col>
            </Row>
            <div className="separator"></div>
            <Row className="mt-3 mb-1">
              <Col className="text-start">
              <div className="mt-1">
  <p className="text-muted mb-0 label-text">Tax Invoice Number</p>
  <p className="value-text">
    {currentOrder?.data?.invoice_id || "--"}
  </p>
</div>
               <div className="mt-1">
  <p className="text-muted mb-0 label-text">Tax Invoice ID</p>
  <p className="value-text">
    {currentOrder?.data?.system_invoice_id || `INV-${currentOrder?.data?.orderId}`}
  </p>
</div>

                <div className="mt-1">
                  <p className="text-muted mb-0 label-text">Invoice Date</p>
                  <p className="value-text">{TimestampConverter(currentOrder?.data?.order_date)}</p>
                </div>
                <div className="mt-1">
                  <p className="text-muted mb-0 label-text">Payment Method</p>
                  <p className="value-text">
                    {currentOrder?.data?.payment_method_id?.slug === "pay-now" ? "Online" : "POD"}
                  </p>
                </div>
                <div className="mt-1">
                  <p className="text-muted mb-0 label-text">Payment Transaction ID</p>
                  <p className="value-text">
                    {currentOrder?.data?.razorpay_payment_id ||
                      currentOrder?.data?.parentOrder?.razorpay_payment_id ||
                      "--"}
                  </p>
                </div>
              </Col>
              <Col className="text-end">
                <div className="mt-1">
                  <p className="price-text mb-1">{finalTotal.toFixed(2)} ₹</p>
                </div>
                <div className="mt-1">
                  <p className="price-value-text">Subtotal: {orderSubTotal.toFixed(2)} ₹</p>
                  <p className="price-value-text">
                    Delivery Charges: {currentOrder?.data?.totalDelivery || "0.00"} ₹
                  </p>
                  <p className="price-value-text">
                    Handling Charges: {currentOrder?.data?.totalHandlingCharges || "0.00"} ₹
                  </p>
                </div>
                <div className="mt-1">
                  <p className="price-value-text text-muted small">Includes:-</p>
                  <p className="price-value-text">SGST: {grandTotalSGST.toFixed(2)} ₹</p>
                  <p className="price-value-text">CGST: {grandTotalCGST.toFixed(2)} ₹</p>
                  <p className="price-value-text">IGST: 0.00 ₹</p>
                  <p className="price-value-text mt-1 text-primary">
                    {orderDiscount > 0 && (
                      <>You saved (Discount): {orderDiscount.toFixed(0) + ".00"} ₹</>
                    )}
                  </p>
                </div>
                <div className="mt-2"></div>
              </Col>
            </Row>
            <Table bordered hover className="vertical-borders-only align-middle no-hover">
              <thead>
                <tr>
                  <th>#</th>
                  <th className="text-start" style={{ width: 450 }}>
                    Item & Description
                  </th>
                  <th>HSN/ SAC</th>
                  <th>Qty</th>
                  <th>Rate</th>
                  <th>Basic Amount</th>
                  <th>
                    Tax
                    <br />
                    Type
                  </th>
                  <th>
                    Tax
                    <br />
                    Amount
                  </th>
                  <th>Total Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>01</td>
                  <td className="text-start">
                    <span>
                      {productVariant?.brand_name} - {convertToLiters(productVariant?.quantity)}
                    </span>
                    <br />
                    <small className="fst-italic">
                      {productVariant?.product_name}
                      <br />
                      {productVariant?.packaging_size} Bottle Per Case
                    </small>
                  </td>
                  <td>{productVariant?.hns}</td>
                  <td>
                    {currentOrder?.data?.moq}
                    <br />
                    <small>case(s)</small>
                  </td>
                  <td className="text-end">{"₹" + rateWithoutGST}</td>
                  <td className="text-end">{"₹" + totalWithoutGST}</td>
                  <td className="text-end">
                    CGST({hsnCGST}%)
                    <br />
                    SGST({hsnSGST}%)
                  </td>
                  <td className="text-end">
                    <span>{"₹" + finalCGST.toFixed(2)}</span>
                    <br />
                    <span>{"₹" + finalSGST.toFixed(2)}</span>
                  </td>
                  <td className="text-end">{"₹" + orderSubTotal.toFixed(0)}</td>
                </tr>

                <tr>
                  <td>02</td>
                  <td className="text-start">
                    <span>Delivery Charges</span>
                  </td>
                  <td>{appConstants.DELIVERY_CHARGES_SAC}</td>
                  <td>
                    {currentOrder?.data?.moq}
                    <br />
                    <small>case(s)</small>
                  </td>
                  <td className="text-end">{"₹" + deliveryRate}</td>
                  <td className="text-end">{"₹" + deliveryWithoutGST}</td>
                  <td className="text-end">
                    CGST(9%)
                    <br />
                    SGST(9%)
                  </td>
                  <td className="text-end">
                    <span>{"₹" + deliveryCGST.toFixed(2)}</span>
                    <br />
                    <span>{"₹" + deliverySGST.toFixed(2)}</span>
                  </td>
                  <td className="text-end">
                    {"₹" + parseFloat(currentOrder?.data?.totalDelivery).toFixed(0)}
                  </td>
                </tr>

                <tr>
                  <td>03</td>
                  <td className="text-start">
                    <span>Handling Charges</span>
                  </td>
                  <td>{appConstants.HANDLING_CHARGES_SAC}</td>
                  <td>
                    {currentOrder?.data?.moq}
                    <br />
                    <small>case(s)</small>
                  </td>
                  <td className="text-end">{"₹" + handlingRate}</td>
                  <td className="text-end">{"₹" + handlingWithoutGST}</td>
                  <td className="text-end">
                    CGST(9%)
                    <br />
                    SGST(9%)
                  </td>
                  <td className="text-end">
                    <span>{"₹" + handlingCGST.toFixed(2)}</span>
                    <br />
                    <span>{"₹" + handlingSGST.toFixed(2)}</span>
                  </td>
                  <td className="text-end">
                    {"₹" + parseFloat(currentOrder?.data?.totalHandlingCharges).toFixed(0)}
                  </td>
                </tr>

                {/* Add empty rows */}
                {Array.from({ length: 8 }, (_, i) => i + 1).map((num) => (
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <Row>
              <Col xs={12} md={12} className="text-end" style={{ marginTop: "25px" }}>
                {currentOrder?.data?.seller_id?.authorized_signature && (
                  <Image
                    fluid
                    style={{ height: "80px" }}
                    src={currentOrder?.data?.seller_id?.authorized_signature}
                  />
                )}
              </Col>
            </Row>
            <Row
              className="signature"
              style={{
                marginTop: currentOrder?.data?.seller_id?.authorized_signature ? "-25px" : "90px",
              }}
            >
              <Col className="text-start">
                <p className="mb-0">
                  <span className="text-muted label-text">Order Number: </span>
                  <span className="value-text">{currentOrder?.data?.orderId}</span>
                  <br />
                  <span className="text-muted label-text">Order Date: </span>
                  <span className="value-text">
                    {TimestampConverter(currentOrder?.data?.order_date)}
                  </span>
                  <br />
                  {currentOrder?.data?.status !== "delivered" ? (
                    <>
                      <span className="text-muted label-text">Expected Delivery Date: </span>
                      <span className="value-text">
                        {TimestampConverter(currentOrder?.data?.expected_delivery_date, true)}
                      </span>
                    </>
                  ) : (
                    <>
                      <span className="text-muted label-text">Delivered Date: </span>
                      <span className="value-text">
                        {TimestampConverter(currentOrder?.data?.delivered_at, true)}
                      </span>
                    </>
                  )}
                </p>
              </Col>
              <Col className="text-end fw-bolder">
                <p className="mb-0 value-text">
                  <span className="text-muted label-text">&nbsp;</span>
                  <br />
                  <span className="value-text">Authorized Signatory</span>
                </p>
              </Col>
            </Row>
            <div className="separator"></div>
            <Row className="mt-1">
              <Col className="text-start">
                <p className="value-text mb-1">
                  {currentOrder?.data?.billing_address_id?.full_name}
                </p>
                <p className="text-muted label-text office-text">
                  {currentOrder?.data?.billing_address_id?.address_line_1}
                </p>
                <p className="text-muted label-text office-text">
                  {currentOrder?.data?.billing_address_id?.city}{" "}
                  {currentOrder?.data?.billing_address_id?.pin_code}{" "}
                  {currentOrder?.data?.billing_address_id?.state}{" "}
                  {currentOrder?.data?.billing_address_id?.country}
                </p>
                <p className="text-muted label-text office-text">State code: {billingStateCode}</p>
                <p className="text-muted label-text office-text">
                  Place of Supply: {currentOrder?.data?.delivery_address_id?.state}
                </p>
                {currentOrder?.data?.buyerInfo?.gst_no && (
                  <p className="text-muted label-text office-text">
                    GSTIN: {currentOrder?.data?.buyerInfo?.gst_no}
                  </p>
                )}
              </Col>
              <Col className="text-end">
                <p className="value-text mb-1">
                  <span className="text-muted label-text fst-italic">Sold By: </span>
                  {currentOrder?.data?.seller_id?.business_name}
                </p>
                <p className="text-muted label-text office-text">
                  {currentOrder?.data?.seller_address_id?.address_line_1}{" "}
                  {currentOrder?.data?.seller_address_id?.address_line_2}
                </p>
                <p className="text-muted label-text office-text">
                  {currentOrder?.data?.seller_address_id?.city}{" "}
                  {currentOrder?.data?.seller_address_id?.pin_code}{" "}
                  {currentOrder?.data?.seller_address_id?.state}{" "}
                  {currentOrder?.data?.seller_address_id?.country}
                </p>
                <p className="text-muted label-text office-text">State code: {sellerStateCode}</p>
                <p className="text-muted label-text office-text">
                  GSTIN: {currentOrder?.data?.seller_id?.gst_no}
                </p>
              </Col>
            </Row>
          </Container>
        </>
      )}
      {currentOrder?.data?.invoice_status === false && (
        <>
          <Container className="mt-2 mb-2 p-0 no-print">
            <Row>
              <Col className="text-start">
                <Button className="btn btn-primary btn-sm" onClick={handleGoBack}>
                  <i class="bi bi-chevron-left"></i> Back
                </Button>
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <p className="text-center">Invoice is not generated.</p>
              </Col>
            </Row>
          </Container>
        </>
      )}
    </>
  );
};

export default Invoice;
